import endpoints from '../endpoints.ts';
import api from '../api/index.ts';
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { Contact } from '../types/models.ts';
import { TradingPartnerType } from '../enums.ts';

export const TRADING_PARTNER_QUERY_KEY = 'TRADING_PARTNER_QUERY_KEY';

const useReadAllByUserId = () =>
  useQuery({
    queryKey: [
      TRADING_PARTNER_QUERY_KEY,
      endpoints.tradingPartner.read.all.by.userId(),
    ],
    queryFn: api.tradingPartner.read.all.by.userId,
  });

const useReadAllContactsByOutboundDocumentId = (
  outboundDocumentId?: string | number,
  options?: Partial<UseQueryOptions<Contact[] | null>>
): UseQueryResult<Contact[] | null> =>
  useQuery({
    enabled: Boolean(outboundDocumentId),
    queryKey: [
      TRADING_PARTNER_QUERY_KEY,
      endpoints.tradingPartner.read.many.tradingPartnerContacts.by.outboundDocumentId(),
      outboundDocumentId,
    ],
    queryFn: () =>
      api.tradingPartner.read.many.tradingPartnerContacts.by.outboundDocumentId(
        outboundDocumentId ?? 0
      ),
    ...options,
  });

const useReadManyBySearch = (
  params: {
    name: string;
    gln: string;
    stateId: string | number;
    type: TradingPartnerType;
  },
  options?: Partial<UseQueryOptions<any | null>>
) =>
  useQuery({
    queryKey: [
      TRADING_PARTNER_QUERY_KEY,
      endpoints.tradingPartner.read.many.tradingPartners.search(),
      params,
    ],
    queryFn: () => api.tradingPartner.read.many.tradingPartners.search(params),
    ...options,
  });

const tradingPartnerQueryHooks = {
  useReadAllByUserId,
  useReadAllContactsByOutboundDocumentId,
  useReadManyBySearch,
};

export default tradingPartnerQueryHooks;
